import { RescheduleFilters, RescheduleItemKind, RescheduleItemType, RescheduleReasonFilter } from "@myapp/contract";

export interface RescheduleFiltersForm {
  type: RescheduleItemType | "";
  kind: RescheduleItemKind | "";
  title: string;
  technicianName: string;
  reason: RescheduleReasonFilter | "";
  dateFrom: string;
  dateTo: string;
  sortField: "scheduledDate" | "type" | "technicianName";
  sortDirection: "ASC" | "DESC";
}

export const INITIAL_RESCHEDULE_FILTERS: RescheduleFiltersForm = {
  type: "",
  kind: "",
  title: "",
  technicianName: "",
  reason: "" as RescheduleReasonFilter | "",
  dateFrom: "",
  dateTo: "",
  sortField: "scheduledDate",
  sortDirection: "DESC",
};

export const mapFiltersFormToApi = (
  filters: RescheduleFiltersForm,
  limit: number,
): RescheduleFilters => ({
  limit,
  type: filters.type || undefined,
  kind: filters.kind || undefined,
  title: filters.title || undefined,
  technicianName: filters.technicianName || undefined,
  reason: filters.reason || undefined,
  dateFrom: filters.dateFrom || undefined,
  dateTo: filters.dateTo || undefined,
  sortField: filters.sortField,
  sortDirection: filters.sortDirection,
});
